import type { SourceChangeApprovalRow } from "../types"

import type { SourceChangeApprovalProduct } from "@/graphql/codegen/graphql"

export const toSourceChangeApprovalRows = (products: SourceChangeApprovalProduct[]): SourceChangeApprovalRow[] =>
  products.flatMap(({ product, records }) => records.map((record) => ({ product, record })))
